import React, { useEffect } from "react";
// import Navbar from "../../PrivacyPolicy/Navbar";
import { Box, Container, Grid } from "@mui/material";
import Getstarted from "../About/Getstarted";
import Featuresofdesihisab from "./Featuresofdesihisab";
import FooterSection from "../../Footer/FooterSection";
// import backgroundImage from "../../../images/backgroundimg.png";
// import Mainstyle from "../../../style.module.css";
import styles from "./Features.module.css";
import { featuresTitle } from "../../Constants";

const Features = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0 });
  }, []);
  return (
    <>
      <Box>
        {/* <Navbar
          pageName={{
            navbarName: "FEATURES",
            backimg: backgroundImage,
          }}
        /> */}
      </Box>
      <Container maxWidth="xl">
        <div style={{ padding: "0 28px" }}>
          <Grid container className={styles.featuresmainwrap}>
            <Grid item xs={12}>
              <div className={styles.title}>{featuresTitle.title}</div>
              <div className={styles.subtitle}>{featuresTitle.subTitle}</div>
            </Grid>
          </Grid>
        </div>
      </Container>
      <div className={styles.Featuresofdesihisabwrap} >
          <Featuresofdesihisab />
      </div>
      <Getstarted />
      <FooterSection />
    </>
  );
};
export default Features;
